export const PropertyShareStatsGtmCtaFinish = {
  name: 'User Interaction',
  label: 'Social Sharing',
  action: 'Finish:Email Share',
};
